/*eslint-disable */
import React, { useState } from "react";

// Custom Components
import Table from "@Components/Table";
import withSelect from "../withSelect";
import Filter from "components/Filter";
import { URLS } from "configs/constants";

let model = [
  { id: "name", label: "Name", type: "string" },
  { id: "status_label", label: "Status", type: "string" },
];

const actions = ["edit"];

const filterInitialValues = {
  name: "",
  active: null,
};

const UrgencyLevelList = () => {
  const [filterValues, setFilterValues] = useState({});
  const filterFields = [
    {
      type: "input",
      label: "Name",
      name: "name",
    },
    {
      type: "reactselect",
      name: "active",
      label: "Status",
      outerOptions: [
        { id: "1", name: "ACTIVE" },
        { id: "0", name: "INACTIVE" },
      ],
    },
  ];

  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <div>
      {/* FIXME: 10953 - Filter hidden for now */}
      <Filter
        initialValues={filterInitialValues}
        filterFields={filterFields}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL="urgency-level/bo-list/"
        model={model}
        actions={actions}
        filterValues={filterValues}
        noFilter
      />
    </div>
  );
};

export default withSelect(UrgencyLevelList, URLS.URGENCY_LEVEL_CUSTOM_FIELDS);
